import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

import { bootbox } from "../../infrastructure/bootbox-shim";
import { modelServices } from "../../scripts/ah.mb.ui.model-services";

export interface IModelEventUserNotification {
    id: string;
    eventName: string;
    enabled: boolean;
    emailRecipients: Array<string>;
    customMessage: string;
}

//export interface IModelEventUserNotifications {
//    userNotifications: Array<IModelEventUserNotification>
//}


@Component
export default class EventNotificationsEditorDialog extends Vue {


    @Prop()
    value: IModelEventUserNotification[]; // = { mode: "create",  }

    @Prop()
    modelServices: modelServices;


    mounted() {
        // this.setupNodeTypesLookup(this.value.modelId);
    }

    @Watch("value.modelId", { deep: false })
    onModelIdChanged() {
        //        this.onReportNodePathAndNameChanged();
    }

    onCancelClick() {
        this.$emit("dialogClosed", "cancel");
    }

    // Todo: Hook this up to ok button
    onSaveClick() {

        this.$emit("dialogClosed", "ok");

    }

    onAddRecipientClick(event: IModelEventUserNotification) {
        bootbox.prompt({
            title: `Add Recipient Email`,
            content: "",
            callback: (value) => {

                if (value) {
                    var regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
                    var emailOk = regexp.test(value);
                    if (!emailOk) {
                        bootbox.alert(`"${value}" is not a valid email address`)
                    }
                    else {
                        event.emailRecipients.push(value);
                        this.autoUpdateEventEnabled(event);
                    }
                }
            }
        });
    }

    onRemoveRecipientClick(eventName: string, recipient: string) {
        var event = this.value.find(val => val.eventName == eventName);
        const index = event.emailRecipients.indexOf(recipient);
        event.emailRecipients.splice(index, 1);
        this.autoUpdateEventEnabled(event);

    }

    autoUpdateEventEnabled(event: IModelEventUserNotification) {
        event.enabled = event.emailRecipients.length > 0;
    }

    onCustomCommentsClick(event: IModelEventUserNotification) {
        bootbox.prompt({
            title: `Custom Comments`,
            content: event.customMessage,
            callback: (value) => {

                if (value) {
                    event.customMessage = value;
                    }
                }
        });

    }


}





// WEBPACK FOOTER //
// ./ClientApp/components/event-notifications-editor-dialog/event-notifications-editor-dialog.ts